<script setup lang="ts">
import { onMounted } from 'vue';
import { getGoogleDriveUrl } from '~/utils';

interface Props
{
  compromisso?: any
  fluxo?: any
}

const props = defineProps<Props>();

const emit = defineEmits(['loaded']);

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    :column="3"
    bordered
  >
    <a-descriptions-item
      v-for="(mensagem, index) in props.compromisso.data.resultados"
      :key="mensagem"
      :span="3"
    >
      {{ index + 1 }} - {{ mensagem }}
    </a-descriptions-item>
  </a-descriptions>
  <a-descriptions
    v-if="props.compromisso.data.planilhaNome"
    :column="3"
    bordered
    style="margin-top: 24px"
  >
    <a-descriptions-item
      label="Planilha"
      :span="3"
    >
      <a
        target="_blank"
        :href="getGoogleDriveUrl(props.compromisso.data.planilhaFileServiceId)"
      >{{
        props.compromisso.data.planilhaNome
      }}</a>
    </a-descriptions-item>
  </a-descriptions>
</template>
